"use client"

import { ClassValue } from "clsx"
import { HeartIcon } from "lucide-react"

import { cn } from "@/lib/utils"
import { useRestaurantLike } from "@/hooks/use-restaurant-like"

import { Button } from "./ui/button"

interface LikeButtonProps {
  restaurantId: number
  compact?: boolean
  className?: ClassValue
}

export function LikeButton({
  restaurantId,
  compact = false,
  className,
}: LikeButtonProps) {
  const { isLiked, isPending, isLoading, toggleFavorite, isAuthenticated } =
    useRestaurantLike(restaurantId)

  if (!isAuthenticated) {
    return null
  }

  if (compact) {
    return (
      <Button
        variant="ghost"
        className={cn(
          "shrink-0 relative shadow rounded-full size-8 cursor-pointer disabled:opacity-100",
          isPending && "opacity-70 pointer-events-none",
          className
        )}
        onClick={toggleFavorite}
        disabled={isPending || isLoading}
        aria-label={isLiked ? "Bỏ yêu thích" : "Yêu thích"}
      >
        <HeartIcon
          className={cn(
            "text-gray-700 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
            isLiked && "text-rose-500 fill-rose-500"
          )}
          size={14}
        />
      </Button>
    )
  }

  return (
    <Button
      variant="secondary"
      className={cn(
        "shrink-0 bg-white disabled:opacity-100 text-gray-900 flex items-center gap-1.5 py-0 font-semibold rounded-full shadow-[0px_10px_24px_0px_rgba(0,0,0,0.16)] border-none",
        isPending && "opacity-70 pointer-events-none",
        className
      )}
      onClick={toggleFavorite}
      disabled={isPending || isLoading}
    >
      <HeartIcon
        className={cn(
          "text-gray-800",
          isLiked && "text-rose-600 fill-rose-600"
        )}
        size={12}
        strokeWidth={2.5}
      />
      {!compact && (isLiked ? "Bỏ thích" : "Yêu thích")}
    </Button>
  )
}
